import Card from "./components/Data";
import Hero from "./components/Hero";

function App() {
  return (
    <div className="App">
      <Hero />
      <Card />
    </div>
  );
}

export default App;
